





















import Vue from "vue";
import FullscreenBtn from "@/components/FullscreenBtn.vue";
import NotPermitted from "@/views/NotPermitted.vue";

import { BimViewer_bimViewer, Project_project } from "@/api-types";
import BIM_VIEWER from "@/graphql/projects/BimViewer.gql";

export default Vue.extend({
  components: { FullscreenBtn, NotPermitted },
  props: { project: Object as () => Project_project },
  apollo: {
    bimViewer: {
      query: BIM_VIEWER,
      variables() {
        return { id: this.project.bimViewer!.id };
      },
      result() {
        document.title = `Hydromapper - BIM Viewer vom Projekt '${
          this.project.name
        }'`;
        this.$store.commit(
          "setToolbarTitle",
          `${this.project.name}: BIM Viewer`
        );
      }
    }
  },
  data: () => ({
    bimViewer: null as BimViewer_bimViewer | null
  })
});
